<template>
  <div class="app-window">
    <ion-header>
      <ion-toolbar>
        <ion-title>Contact Details</ion-title>
        <ion-buttons slot="start">
          <ion-back-button></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <img src="/assets/banner-w700.png"/>
      <ion-grid>
        <ion-row>
          <ion-item>
            We always strive to maintain confidentiality of your information. We will only use your details to communicate with you. If you like to give consent for us to communicate with you by
            mobile text messaging and / or email please fill in the form below.
          </ion-item>
        </ion-row>
        <ion-row>
          <ion-col size="12" size-md="6">
            <ion-item>
              <ion-label position="stacked">First Name</ion-label>
              <ion-input v-model="signupInfo.first_name" type="text" placeholder="Your Name"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-item>
              <ion-label position="stacked">Last Name</ion-label>
              <ion-input v-model="signupInfo.last_name" type="text" placeholder="Your Family Name"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" size-md="6">
            <ion-item>
              <ion-label position="stacked">Email</ion-label>
              <ion-input v-model="signupInfo.email" type="email" placeholder="Your Email Address"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-item>
              <ion-label position="stacked">Telephone</ion-label>
              <ion-input v-model="signupInfo.telephone" type="telephone" placeholder="Your Contact Number"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <ion-item>
              <ion-label position="stacked" style="margin-bottom: 3px">How did you get to know about EOPP?</ion-label>
              <ion-select placeholder="Select" interface="action-sheet"  style="width: 20em"
                          v-bind:value="signupInfo.source"
                          v-on:ionChange="selectSource($event.detail.value)">
                <ion-select-option v-for=" o in sources" v-bind:value="o" v-bind:key="o.code">{{ o.name }}</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
          <ion-col size="6">
            <ion-item v-if="signupInfo.source && signupInfo.source.code === 'other'">
              <ion-label position="stacked">Please specify the Source</ion-label>
              <ion-input v-model="otherSource"  placeholder="Source Name"></ion-input>
            </ion-item>

          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label position="stacked">Details</ion-label>
              <ion-textarea v-model="signupInfo.comments" rows="2" placeholder="Please provide any additional details you want to specify"></ion-textarea>
            </ion-item>
          </ion-col>
        </ion-row>
<!--        <ion-row>-->
          <!--            <re-captcha></re-captcha>-->
          <!--                        <re-captcha (resolved)="reCapchaResolved($event)" siteKey="6LfOl7AZAAAAABw6URm9_zSDNH3QD6reGCLOLlHP"></re-captcha>-->
<!--        </ion-row>-->
        <ion-row>
          <ion-col>
            <ion-item>
              <p>I agree to allow EOPP to store and process my personal data</p>
              <ion-checkbox v-model="signupInfo.consent" color="primary" slot="start"></ion-checkbox>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-button expand="block" v-on:click="proceed()" style="width: 20em; margin: 1em auto; ">PROCEED
            <ion-icon slot="end" :icon="chevronForwardOutline"></ion-icon>
          </ion-button>
        </ion-row>

        <ion-row>
          <ion-item>
            We are different to any other service provider out there at the moment. At Eopp , We strongly believe that if you have the right qualifications and experience, you must be given an
            opportunity to achieve what you desire. If you do not have the qualifications and experience, we can help you to acquire those qualifications and experience to help you get to the
            place you dream of.
            <br>
          </ion-item>
          <ion-item><br>
            If you have, the right Qualifications, experience, talent and more than anything else, you have the commitment and drive to pursue your dreams, we are at your service to provide you
            with the opportunity to achieve your goals.
          </ion-item>
        </ion-row>
      </ion-grid>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <ion-button slot="start" color="secondary" v-on:click="back()">
          <ion-icon slot="start" :icon="chevronBackOutline"></ion-icon>
          BACK
        </ion-button>
        <ion-button slot="end" v-on:click="proceed()">
          PROCEED
          <ion-icon slot="end" :icon="chevronForwardOutline"></ion-icon>
        </ion-button>
      </ion-toolbar>
    </ion-footer>
  </div>
</template>

<script>
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonFooter,
  IonButton,
  IonIcon,
  IonItem,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
  IonTextarea,
  IonBackButton,
  IonButtons,
  IonCheckbox,
  IonLabel, IonSelect, IonSelectOption
} from '@ionic/vue';
import {
  chevronForwardOutline,
  chevronBackOutline
} from 'ionicons/icons';

import EoppService from "@/mixins/EoppService";
import router from "./Router";
import MessageService from "@/mixins/MessageService";
import gtmService from "@/services/GoogleTagService";

export default {
  name: 'ContactDetails',
  components: {
    IonSelectOption, IonSelect,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonFooter,
    IonButton,
    IonIcon,
    IonItem,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    IonTextarea,
    IonBackButton,
    IonButtons,
    IonCheckbox,
    IonLabel
  },
  mixins: [
    EoppService,
    MessageService
  ],
  data() {
    return {
      chevronForwardOutline,
      chevronBackOutline,
      signupInfo: {},
      otherSource: null,
      sources: [
        {code: 'facebook', name: 'Facebook'},
        {code: 'other social', name: 'Other Social Media'},
        {code: 'referred by', name: 'Referred by Eopp Client'},
        {code: 'unizone', name: 'UniZone'},
        {code: 'ekandy', name: 'E-Kandy'},
        {code: 'eac', name: 'E-AC'},
        {code: 'egf', name: 'E-GF'},
        {code: 'erama', name: 'E-Rama'},
        {code: 'JJ', name: 'JJ'},
        {code: 'SDS', name: 'SDS'},
        {code: 'other', name: 'Other'},
      ]
    };
  },
  mounted() {
    if (!this.quizAnswers) {
      this.back();
    }

    gtmService.saveAcivity('enrol/contact-detail', 'enrol/contact-detail' );


    if (this.prevSignupInfo) {
      this.signupInfo.first_name = this.prevSignupInfo.first_name;
      this.signupInfo.last_name = this.prevSignupInfo.last_name;
      this.signupInfo.email = this.prevSignupInfo.email;
      this.signupInfo.telephone = this.prevSignupInfo.telephone;
    }
  },
  methods: {
    back: async function () {
      await router.push({path: '/quiz'})
    },
    selectSource: async function (source) {
      console.log(source)
      this.signupInfo.source = source;
    },
    proceed: async function () {
      // await router.push({path: '/quizl2'})
      if (!this.signupInfo.first_name || this.signupInfo.first_name.trim().length === 0) {
        this.toast('Warning', 'Please Provide a Valid First Name');
        return;
      }

      if (!this.signupInfo.last_name || this.signupInfo.last_name.trim().length === 0) {
        this.toast('Warning', 'Please Provide a Valid Last Name');
        return;
      }

      if (!this.signupInfo.email || this.signupInfo.email.trim().length === 0) {
        this.toast('Warning', 'Please Provide a Valid Email');
        return;
      }

      if (!this.signupInfo.consent) {
        this.toast('Warning', 'We are unable to process without your consent to store and process your data ');
        return;
      }

      if (!this.signupInfo.source) {
        this.toast('Warning', 'Please Select Your Source');
        return;
      }

      if (this.signupInfo.source.code === 'other') {
        if (!this.otherSource) {
          this.toast('Warning', 'Please Specify Your Source Details');
          return;
        } else {
          this.signupInfo.source.name = this.otherSource;
        }
      }

      let recaptcha = await gtmService.recaptcha('enrol');
      this.postData(`/signup?recaptcha=${recaptcha}`, this.signupInfo).then(async res => {
        console.log(res);
        this.$store.commit('signupInfo', this.signupInfo);
        this.$store.commit('signupId', res.data);
        // this.closeProgressIndicator();
        // await router.push({path: '/email-verification'})
        await this.proceedToResults();
      },);
    },
    proceedToResults: async function () {
      this.presentProgressIndicator( 4000 );
      // this.signupId.token = this.token;

      // this.postData('/signup/verify', this.signupId).then(async res => {
      //   if (res.data === 'SUCCESS') {
          this.signupInfo.verified = true;
          this.signupInfo.id = this.signupId.id;
          this.signupInfo.criteria = this.quizAnswers;

          gtmService.saveAcivity('enrol/enrolled', 'enrol/enrolled' );

          this.postData(`/enrol`, this.signupInfo).then(async vres => {
            if (vres.data) {
              this.signupInfo.results = vres.data;
              localStorage.setItem('eopp-results', JSON.stringify(this.signupInfo));
              await router.push({path: '/results'})
            } else {
              this.toast('Error', 'Error Loading Results');
            }
          });
        // } else {
        //   this.toast('Warning', 'Verification Failed, Please Check your details and try again');
        // }
    }
  }
}
</script>
<style>

</style>
